import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <footer className="bg-reset-dark text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <div className="md:col-span-5">
            <img 
              src="https://static.readdy.ai/image/c547be34c1bf7bb39243860cf03ecf7c/b9a533f96a7d792ab1739b73d5695be7.png" 
              alt="RE:SET" 
              className="h-12 w-auto mb-8 brightness-0 invert"
            />
            <p className="text-base text-white/80 leading-relaxed max-w-sm">
              A modern approach to longevity through regenerative wellness
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-widest text-white/60 mb-6 font-semibold">CONNECT</h4>
            <div className="space-y-5">
              <a href="https://www.instagram.com/re.set.now/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm hover:text-reset-sage transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-lg w-5 h-5 flex items-center justify-center"></i>
                <span>Instagram</span>
              </a>
              <a href="https://www.tiktok.com/@reset4154?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm hover:text-reset-sage transition-colors duration-300 cursor-pointer">
                <i className="ri-tiktok-line text-lg w-5 h-5 flex items-center justify-center"></i>
                <span>TikTok</span>
              </a>
              <a href="mailto:hello@reset-wellness.com" className="flex items-center gap-3 text-sm hover:text-reset-sage transition-colors duration-300 cursor-pointer">
                <i className="ri-mail-line text-lg w-5 h-5 flex items-center justify-center"></i>
                <span>Email</span>
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-widest text-white/60 mb-6 font-semibold">STAY INFORMED</h4>
            <form onSubmit={handleSubmit} className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="w-full bg-white/10 border border-white/20 rounded-full px-6 py-4 pr-14 text-sm text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors duration-300"
                required
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-white/90 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-arrow-right-line text-reset-sage text-lg w-5 h-5 flex items-center justify-center"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/60">
          <p>© 2025 RE:SET WELLNESS SANCTUARY. ALL RIGHTS RESERVED.</p>
          <div className="flex items-center gap-6">
            <a href="/privacy" className="hover:text-white transition-colors duration-300 cursor-pointer whitespace-nowrap uppercase tracking-wide">Privacy</a>
            <a href="/terms" className="hover:text-white transition-colors duration-300 cursor-pointer whitespace-nowrap uppercase tracking-wide">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
